if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    //CMS forms label animation
    if(document.getElementsByClassName('planning-form-entry').length > 0){
		let allffields = document.getElementsByClassName('planning-form-entry');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.previousElementSibling.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.previousElementSibling.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.previousElementSibling.classList.add('moved');
			   })
		   }
	   }
	}
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.previousElementSibling.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.previousElementSibling.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.previousElementSibling.classList.add('moved');
			   })
		   }
	   }
	}
	 if(document.getElementsByClassName('field').length > 0){
		 let allfields = document.getElementsByClassName('field');
	 	
		for(let j = 0; j < allfields.length; j++){
			
			if(allfields[j].getElementsByTagName('input').length > 0){
				if(allfields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allfields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
					allfields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
						this.previousElementSibling.classList.add('moved');
					})
				}
			}
			if(allfields[j].getElementsByTagName('select').length > 0){
				allfields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
					this.previousElementSibling.classList.add('moved');
				})
			}
			if(allfields[j].getElementsByTagName('textarea').length > 0){
				allfields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
					this.previousElementSibling.classList.add('moved');
				})
			}
		}
	}
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.reviews').slick({
        fade:true,
        accessibility: false,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                arrows:false,
                dots: true,
                adaptiveHeight:true
              }
            }
        ]
    });
    $('.reasons-slider').slick({
		slidesToShow: 3,
  		slidesToScroll: 1,
		accessibility: false,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			}
		]
    });
    
    $('.slider-images').slick({
		arrows:false,
		accessibility:false,
		slidesToShow :2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow:1
				}
			}
		]
	});
	$('.slider-gallery__gallery-container').slick({
		centerMode:true,
		accessibility:false,
		slidesToShow:3,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow:2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow:1
				}
			}
		]
	});

})();